import {NgModule} from '@angular/core';
import {AddressFieldsComponent} from './address-fields.component';
import {FormFieldModule} from '@components/form-field/form-field.module';
import {KladrService} from './kladr.service';
import {Select2Module} from 'ng2-select2';
import {CommonModule} from '@angular/common';
import {LayoutModule} from '../../layout-components/layout.module';

/**
 * Модуль группы полей для заполнения адреса.
 * Включает в себя выбор города, заполнение индекса и адреса в виде строки
 */

@NgModule({
    declarations: [AddressFieldsComponent],
    imports: [
        CommonModule,
        FormFieldModule,
        Select2Module,
        LayoutModule
    ],
    exports: [AddressFieldsComponent],
    providers: [KladrService]
})
export class AddressFieldsModule {}
